type InputItem = {
  name: string;
  id_reference: number;
  source: string;
  number_order: number;
};

type OutputItem = {
  id: number;
  label: string;
  type: string;
};

const formatCategoriesData = (data: InputItem[]): OutputItem[] => {
  if (!data || data.length < 1) return [];

  return data
    .filter(item => item.number_order > 0)
    .sort((a, b) => a.number_order - b.number_order)
    .map(item => ({
      id: item.id_reference,
      label: item.name,
      type: item.source.toLowerCase()
    }));
};

export default formatCategoriesData;
